const DEBUG_ENABLED_CONST_NAME = 'rnDebugEnabled';

/**
 * @ngdoc overview
 * @name rhino.core.debug
 * @description Provides the angular constant `rnDebugEnabled` for runtime debugging.  It is enabled for developer builds when the webpack `__DEV__` macro is `true`.
 * It can also be enabled on production builds by input the following on the JavaScript console and reloading the page,
 * ```javascript
 * localStorage.rnDebugEnabled = true
 * ```
 * The intended use is mainly for `$logProvider.debugEnabled(rnDebugEnabled);` and `$compileProvider.debugInfoEnabled(rnDebugEnabled);`.
 *
 * **Note:** `rnDebugEnabled` is not intended as a drop-in replacement for `__DEV__` because `__DEV__` is evaluated at build time and can lead to less generated code during minification when set to `false`.
 */
export default angular.module('rhino.core.debug', [])
  .constant(DEBUG_ENABLED_CONST_NAME, getRnDebugEnabled())
  .name;

function getRnDebugEnabled() {
  // Developers can set this flag on the javascript console with this command,
  //   localStorage.rnDebugEnabled = true
  // and then reload the page to have this constant set to true.
  // It can then be used in $logProvider.debugEnabled(rnDebugEnabled);
  let localStorage = window.localStorage;
  let rnDebugEnabled = !!localStorage[DEBUG_ENABLED_CONST_NAME];

  // Debug is also enabled if the dev macro is set
  return __DEV__ || rnDebugEnabled;
}




// WEBPACK FOOTER //
// ../~/@printos/rhino/src/core/debug/debug.module.js